import {
  Component,
  ContentChild,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
} from '@angular/core';
import { PageEvent, MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { PaginationOptions } from '@uw/core/models/filter.model';
import { ColumnSizeTypes, SizeBasedColumnClasses } from './uw-table.model';
import { DefaultPaginationOptions } from '@uw/core/utils/pagination-util';
import { IsLoadedTableDatasourceMetadata } from '@uw/core/models/is-loaded-list-metadata.model';
import { NoRecordContainerComponent } from '../no-record-container/no-record-container.component';
import { TranslateModule } from '@ngx-translate/core';
// import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
    selector: 'uw-table',
    templateUrl: './uw-table.component.html',
    styleUrls: ['./uw-table.component.scss'],
    imports: [MatPaginator, NoRecordContainerComponent, TranslateModule]
})
export class UwTableComponent<T> {
  @Input()
  metadata!: IsLoadedTableDatasourceMetadata<T>;

  @Input()
  paginationOptions: PaginationOptions = DefaultPaginationOptions;

  @Input()
  displayedColumns!: string[];

  // @Input()
  // enableRowExpansion: boolean= false;

  // @Input()
  // enableRowActions: boolean = false;

  @Output()
  pageChange = new EventEmitter<PageEvent>();

  @Output()
  sortChange = new EventEmitter<any>();

  // @Output()
  // expandRow = new EventEmitter<T | null>();

  @ContentChild(MatSort)
  sort!: MatSort;

  // readonly defaultColumns = ['expand', 'action'];

  // displayedColumnsX: string[] = [];

  length!: number;
  pageSize!: number;
  pageIndex!: number;

  // expandedElement!: T | null;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.metadata && changes.metadata.currentValue) {
      if (this.metadata.dataSource) {
        this.metadata.dataSource.sort = this.sort;
      }
    }

    if (
      changes &&
      changes.paginationOptions &&
      changes.paginationOptions.currentValue
    ) {
      this.pageIndex =
        this.paginationOptions.page !== undefined &&
        this.paginationOptions.page > 0
          ? this.paginationOptions.page - 1
          : 0;
      this.pageSize = this.paginationOptions.limit
        ? this.paginationOptions.limit
        : 10;

      if (this.paginationOptions.length) {
        this.length = this.paginationOptions.length;
      }
    }

    // if (changes && changes.displayedColumns && changes.displayedColumns.currentValue) {

    //   if (this.enableRowExpansion && !this.displayedColumns.includes(this.defaultColumns[0])) {
    //     this.displayedColumns = [this.defaultColumns[0], ...this.displayedColumns];
    //   }

    //   if (this.enableRowActions && !this.displayedColumns.includes(this.defaultColumns[1])) {
    //     this.displayedColumns = [...this.displayedColumns, this.defaultColumns[1]];
    //   }

    // }

    // if (changes && changes.enableRowExpansion && changes.enableRowExpansion.currentValue) {

    //   if (this.displayedColumns) {
    //     this.displayedColumns = [this.defaultColumns[0], ...this.displayedColumns];
    //   } else {
    //     this.displayedColumns = [this.defaultColumns[0]];
    //   }

    //   if (this.enableRowActions && !this.displayedColumns.includes(this.defaultColumns[1])) {
    //     this.displayedColumns = [...this.displayedColumns, this.defaultColumns[1]];
    //   }
    // }

    // if (changes && changes.enableRowActions && changes.enableRowActions.currentValue) {

    //   if (this.displayedColumns) {
    //     this.displayedColumns = [...this.displayedColumns, this.defaultColumns[1]];
    //   } else {
    //     this.displayedColumns = [this.defaultColumns[1]];
    //   }

    //   if (this.enableRowExpansion && !this.displayedColumns.includes(this.defaultColumns[0])) {
    //     this.displayedColumns = [this.defaultColumns[0], ...this.displayedColumns ];
    //   }
    // }
  }

  // ngAfterViewInit() {
  //   setTimeout(() => {
  //     if (this.dataSource) {
  //       this.dataSource.sort = this.sort;
  //     }
  //   });
  // }

  ngAfterContentInit() {
    setTimeout(() => {
      if (this.metadata && this.metadata.dataSource) {
        this.metadata.dataSource.sort = this.sort;
      }
    });
  }

  getColumnClass(size: ColumnSizeTypes): string {
    if (this.displayedColumns.length > 3) {
      return SizeBasedColumnClasses[size];
    }

    return '';
  }

  // onRowExpand(element: T, event: Event) {
  //   this.expandedElement = this.expandedElement === element ? null : element;

  //   this.expandRow.emit(this.expandedElement);
  //   event.stopPropagation();
  // }
}
